module.exports = __webpack_public_path__ + "img/84.2fe5b1cb.jpg";